import { delay } from 'lodash';
import { Colors } from '../consts/Colors.js';

export default class ItemMenu extends Phaser.GameObjects.Container {
    constructor(scene, x, y, data) {
        super(scene, x, y, []);
        scene.add.existing(this);
        // console.log(data)
        this.scene = scene;
        this.title = data.title
        this.content = data.content
        this.nextActivite = data.nextActivite
        this.illu = data.illu + "Illu"
        this.cadre = data.illu + "Cadre"
        this.illuX = data.illuX
        this.illuY = data.illuY
        this.isLocked = true
        this.isActive = false;
        this.isOpen = false
        this.isFirstClick = true
        this.index = data.index


        this.card = this.scene.add.image(0, 0, this.cadre).setOrigin(0.5).setAlpha(0.5)
        this.illuImage = this.scene.add.image(this.illuX, this.illuY, this.illu).setOrigin(0.5).setAlpha(0)
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });

        this.add(this.card);
        this.add(this.illuImage);

        this.setSize(this.card.width, this.card.height);
        this.setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.clickSound.play();
                // console.log('scene data', this.scene.selectedItem, this.scene.selectedActivity)
                if (!this.isActive) {
                    this.setActive()
                    if (this.index === 1 || this.index === 4) {
                        this.scene.startBtn.setTextContent("Lancer")
                    } else {
                        this.scene.startBtn.setTextContent("Continuer")
                    }
                    if (this.scene.game.data.level === 7){
                        this.scene.card7.setShrinked()
                        this.scene.menu.renfoState()
                    }
                    }else {
                    this.scene.scene.start(this.nextActivite)
                    this.scene.soundCut()
                }

            })
        this.on('pointerover', () => {
            if (this.isActive) {
                // this.setScale(1.07);
                this.scene.tweens.add({
                    targets: this,
                    scale: 1.07,
                    duration: 200,
                    ease: 'Power2'
                });
            }
        })
        this.on('pointerout', () => {
            if (this.isActive) {
                this.scene.tweens.add({
                    targets: this,
                    scale: 1,
                    duration: 200,
                    ease: 'Power2'
                });
            }
        })

    }

    setLocked() {
        this.isLocked = true;
        this.isActive = false;
        this.isOpen = false;
        this.illuImage.setAlpha(0);
        this.card.setAlpha(0.5);
        this.disableInteractive();
    }
    setActive() {
        this.isLocked = false;
        this.isActive = true;
        this.isOpen = false
        this.isFirstClick = true
        this.scene.selectedActivity = this.nextActivite;
        this.scene.selectedItem = this
        this.setClickable()
        this.illuImage.setAlpha(1);
        this.card.setAlpha(1);
        this.setAlpha(1);
        this.scene.activiteTitle.setText(this.title);
        this.scene.activiteContent.setPosition(107, this.scene.activiteTitle.y + this.scene.activiteTitle.height + 20);
        this.scene.activiteContent.setText(this.content);
        this.scene.tweens.add({
            targets: [this.scene.activiteTitle, this.scene.activiteContent],
            delay: 200,
            alpha: 1,
            duration: 400,
            ease: 'Power2',
            onComplete: () => {
                this.scene.startBtn.setAlpha(1)
            }
        })

        this.scene.allItems.forEach(item => {
            if (item !== this && !item.isLocked) {
                item.setOpen();
            }
        });

    }
    setOpen() {
        this.isLocked = false;
        this.isActive = false;
        this.isOpen = true;
        this.setClickable()
        this.illuImage.setAlpha(1);
        this.card.setAlpha(1);
        this.setAlpha(0.5);
        this.isFirstClick = false;
    }

    setClickable() {
        this.setSize(this.card.width, this.card.height);
        this.setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.clickSound.play();
                this.setActive()
            })
    }
}
